import { render, staticRenderFns } from "./commentSetting.vue?vue&type=template&id=039eb82a&scoped=true"
import script from "./commentSetting.vue?vue&type=script&lang=js"
export * from "./commentSetting.vue?vue&type=script&lang=js"
import style0 from "./commentSetting.vue?vue&type=style&index=0&id=039eb82a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039eb82a",
  null
  
)

export default component.exports